import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";

const sliderSettings = {
  items: 3,
  slideBy: "page",
  autoplay: true,
  loop: true,
  controls: true,
  controlsText: ["", "Next"],
  nav: false,
  autoplayButtonOutput: false,
  gutter: 10,
  mouseDrag: true,
  autoplayTimeout: 3000,
  speed: 1000,
  responsive: {
    640: {
      items: 1, // Show 1 item on small screens
    },
    900: {
      items: 2, // Show 2 items on medium screens
    },
    1200: {
      items: 3, // Show 3 items on large screens
    },
  },
};

const MySlider = ({ SliderData }) => {
  return (
    <TinySlider settings={sliderSettings}>
      {SliderData.map((d, index) => (
        <div className="item p-3 text-light" key={index}>
          <div className="d-flex justify-content-center flex-column align-items-center">
            <img className="img-fluid" src={d.Img} alt="img-fluid" />
            <p className="text-center text-dark fs-6 fw-normal m-0 py-1">
              {d.name}
            </p>
            <span className="fs-6 text-dark text-muted fw-normal m-0 text-center">
              {d.Roll}
            </span>
          </div>
        </div>
      ))}
    </TinySlider>
  );
};

export default MySlider;
